import React from 'react';
import cs from 'classnames';
import css from './index.css';

const ToolTip = ({trigger, children, visible, right, disabled}) => (
  <div className={css.wrap}>
    <div className={css.trigger}>
      {trigger}
    </div>
    {
      !disabled && 
      <div className={cs(css.wrapTooltip, {[css.visible]: visible, [css.rightWrap]: right})}>
        <div className={cs(css.tooltip, right && css.rightTooltip, 'qa-tooltip')}>
          {children}
          <div className={cs(css.arrow, right && css.rightArrow)}/>
        </div>
      </div>
    }
  </div>
);

export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/common/ToolTip/index.js